import Icon from '../components/Icon.vue'

Icon.register({
  'file-upload': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM289.2 352H224V432C224 440.9 216.8 448 208 448H176C167.2 448 160 440.9 160 432V352H94.8C80.5 352 73.4 334.7 83.5 324.6L180 228.9C186.6 222.3 197.4 222.3 204 228.9L300.4 324.6C310.6 334.7 303.5 352 289.2 352zM377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105z'
      }
    ]
  }
})
